import { useContext } from "react";
import { PluginContext } from "../providers";

const usePlugin = () => {
  const pluginContext = useContext(PluginContext);

  if (!pluginContext) {
    throw new Error("usePlugin must be used within an PluginProvider");
  }
  return pluginContext;
};

export default usePlugin;
